import { Footer } from './components/Footer'

import './styles.scss'

export const Contact = () => {
    return (
        <section id="contact" className="contact">
            <Footer />
        </section>
    )
}
